// extracted by mini-css-extract-plugin
export var expandIcon = "fr_vB";
export var rotated = "fr_vC";